import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import useSWR from 'swr';
import he from 'he';

import { ADMIN_ACCESS_TOKEN_KEY } from '../../../../App';
import { Worklist } from '@components/organisms';
import { DEFAULT_CURRENT_PAGE } from '@components/organisms/Table/Pagination';
import { Body } from '@components/templates';
import { Sub1Button } from '@components/atoms';
import TrensferHead from '../TransferHead';
import { ReceivingCompany, ReceivingList } from '@models/transfer/receiving';
import { BackButtonStyle, RightButtonSection, StyledFlexColumnsWrapper } from './style';
import { userPageCurrentPageCommonTransferState } from '../atom/common';

const Receiving = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { companyId } = useParams();

  const [accessToken, setAccessToken] = useState('');
  const [selected, setSelected] = useState(false);
  const [valueState, setValueState] = useState({
    searchKey: '',
    searchKeyword: '',
  });

  const setPageConditionsValue = useSetRecoilState(userPageCurrentPageCommonTransferState);

  useEffect(() => {
    if (location.pathname.includes('receiving')) {
      setSelected(true);
    }

    return setSelected(false);
  }, []);

  useEffect(() => {
    const newToken = localStorage.getItem(ADMIN_ACCESS_TOKEN_KEY);
    if (newToken && accessToken !== newToken) {
      setAccessToken(newToken);
    }
  }, []);

  useEffect(() => {
    if (valueState?.searchKeyword)
      setPageConditionsValue((prev) => ({
        ...prev,
        currentPage: DEFAULT_CURRENT_PAGE,
      }));
  }, [valueState]);

  const url = `api/transfer/${companyId}/receiving`;

  const { data, error } = useSWR(!!accessToken.length ? [{ url, accessToken }] : null);

  const list: ReceivingList[] = [];
  const fillData = useCallback(() => {
    const startNo = data.result.length;

    data.result.forEach((item: ReceivingCompany, index: number) =>
      list.push({
        no: startNo - index,
        companyId: item.id,
        companyName: he.decode(item.name),
        createdDatetime: item.createdDatetime,
      }),
    );
  }, [data, list]);

  if (error) {
    return <div>failed to load</div>;
  }

  if (!data) {
    return <div>loading...</div>;
  }

  if (!data.result) {
    if (data.code === 'UNAUTHORIZED') return <Navigate to={'/'} replace={true} />;
  }

  if (data) {
    if (data.code === 'UNAUTHORIZED') return <Navigate to={'/'} replace={true} />;

    if (data.code === '200') {
      fillData();
    }
  }

  return (
    <>
      <Body data-page-type={'table-only'} style={{ height: '815px' }}>
        <StyledFlexColumnsWrapper>
          <TrensferHead />

          <div className={'no-list'}>
            <Worklist
              headers={[
                { label: 'No', data_label: 'no' },
                { label: 'ID', data_label: 'companyId' },
                { label: 'Company', data_label: 'companyName' },
                { label: 'Date', data_label: 'createdDatetime' },
              ]}
              data={{ dataArray: list }}
              searchConditions={valueState}
              setSearchConditions={setValueState}
              includeSearch={true}
            />
          </div>
        </StyledFlexColumnsWrapper>
        <RightButtonSection>
          <Sub1Button onClick={() => navigate('/transfer')} styles={BackButtonStyle}>
            Back
          </Sub1Button>
        </RightButtonSection>
      </Body>
    </>
  );
};

export default Receiving;
